export const defaultKeyExtractor = item => item;

export const idKeyExtractor = item => item.id;
